import MediaLibrary from './vue/media-library/main';
import userMenuToggle from "./components/UserMenuToggle";
import copyToClipboard from "./components/copyUrlToClipboard";
import dynamicArchive from "./vue/dynamic-archive/client";

document.addEventListener( 'DOMContentLoaded', () => {
  userMenuToggle();

  MediaLibrary( '.td-media-library__app' );
  dynamicArchive( '#events-overview__app' );

  Array.from( document.getElementsByClassName( 'js-copy-page-url' ) )?.forEach( el => el.onclick = () => copyToClipboard( el ) );
} );
